import React from "react";
import './footer.css';
import { NavLink } from "react-router-dom";

const Footer = () => {
  return(
    <footer className="imggaa">
      <hr/>
      
      <div className="m-2 p-3 text-center row footerhero">

      <div className="text-left col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          {/*<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="d-block mb-2"><circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line></svg>*/}
          <h5>Tirika Expeditions</h5>
          
      </div>

      <div className="footerheroo col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <ul className="list-unstyled">
            <li>
              <h2>
                <a className="text-body" href="https://www.instagram.com/tirikaexpeditions/?hl=es-la"><i className="fab fa-instagram"></i></a>&nbsp;
                <a className="text-body" href="https://www.youtube.com/@tirikaexpeditions7526/playlists"><i className="fab fa-youtube"></i></a>&nbsp;
              </h2>
            </li>
          </ul>
        </div>
                
        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <h5>Activities</h5>
          <ul className="list-unstyled text-small">
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/explore">Explore</NavLink></li>
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/cycle">Cycle</NavLink></li>
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/climb">Climb</NavLink></li>
          </ul>
        </div>
        
        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">

        </div>
        
        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <h5>About</h5>
          <ul className="list-unstyled text-small">
            {/*<li><NavLink className="nav-link p-0 m-0 text-dark" to="/request_info">FAQs</NavLink></li>*/}
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/our_team">Our team</NavLink></li>
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/request_info">Contact us</NavLink></li>
            <li><NavLink className="nav-link p-0 m-0 text-dark" to="/lost_world">The Lost World</NavLink></li>
          </ul>
        </div>
 
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.jsx